import { Link } from 'react-router-dom';

const footerLinks = [
  { label: '首页', path: '/' },
  { label: '电影分类', path: '/movie-category' },
  { label: '搜索影片', path: '/search' },
  { label: '关于我们', path: '/about' },
];

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="relative overflow-hidden bg-gradient-to-br from-primary-950 via-background-950 to-accent-950 border-t border-background-800">
      <div className="absolute -top-24 -right-16 w-72 h-72 rounded-full bg-primary-500/10 blur-3xl pointer-events-none"></div>
      <div className="relative w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 rounded-md bg-primary-500 flex items-center justify-center text-background-50">
                <i className="ri-film-line text-lg"></i>
              </span>
              <span className="font-heading font-black text-foreground-50 text-lg">善良的小姨子</span>
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed max-w-sm">
              专注剧情电影在线观看的影视门户，提供《善良的小姨子》等影片的剧情介绍、精彩片段与相关推荐，让好故事触手可及。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-100 mb-4 flex items-center gap-2">
              <span className="w-1.5 h-1.5 rounded-full bg-primary-500"></span>
              快捷导航
            </h3>
            <ul className="grid grid-cols-2 gap-y-3 gap-x-4">
              {footerLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-100 mb-4 flex items-center gap-2">
              <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
              温馨提示
            </h3>
            <p className="text-sm text-foreground-300 leading-relaxed">
              本站为影视内容展示演示站点，播放功能为前端效果演示，不提供真实视频流。所有影片资料仅用于内容演示。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <span className="w-9 h-9 rounded-md bg-background-800/70 flex items-center justify-center text-foreground-300">
                <i className="ri-movie-2-line"></i>
              </span>
              <span className="w-9 h-9 rounded-md bg-background-800/70 flex items-center justify-center text-foreground-300">
                <i className="ri-heart-3-line"></i>
              </span>
              <span className="w-9 h-9 rounded-md bg-background-800/70 flex items-center justify-center text-foreground-300">
                <i className="ri-share-forward-line"></i>
              </span>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400 text-center sm:text-left">
            © {year} 善良的小姨子影视站 · 内容仅为演示用途
          </p>
          <p className="text-xs text-foreground-400 text-center sm:text-right flex items-center gap-2">
            <i className="ri-shield-check-line text-secondary-400"></i>
            本站不存储、不提供任何视频文件
          </p>
        </div>
      </div>
    </footer>
  );
}